// Sélection automatique de belles photos d'illustration en fonction du texte
// (présentation / vision) d'un conseiller. Aucune requête réseau : pool curé.
const uns = (u, w = 1400) => `${u}?w=${w}&q=80&auto=format&fit=crop`;
const pex = (u, w = 1400) => `${u}?auto=compress&cs=tinysrgb&w=${w}`;

const POOL = [
  { tags: ["villa", "maison", "piscine", "contemporain", "moderne", "architecture", "neuf"], url: uns("https://images.unsplash.com/photo-1580587771525-78b9dba3b914"), alt: "Villa contemporaine" },
  { tags: ["appartement", "salon", "interieur", "intérieur", "élégant", "elegant", "design", "standing", "lumineux"], url: uns("https://images.unsplash.com/photo-1705326701287-346fc37a2c86"), alt: "Intérieur élégant" },
  { tags: ["campagne", "château", "chateau", "manoir", "propriété", "propriete", "domaine", "demeure", "pierre", "caractère", "caractere", "authentique"], url: pex("https://images.pexels.com/photos/32549422/pexels-photo-32549422.jpeg"), alt: "Demeure de caractère" },
  { tags: ["ville", "urbain", "vue", "penthouse", "prestige", "panorama"], url: uns("https://images.unsplash.com/photo-1632743441209-8a09b8a37e25"), alt: "Appartement avec vue" },
  { tags: ["confiance", "accompagnement", "relation", "conseil", "humain", "service", "client", "écoute", "ecoute", "expertise", "expérience", "experience"], url: uns("https://images.unsplash.com/photo-1759310610325-2c7cb621e5e3"), alt: "Accompagnement sur-mesure" },
  { tags: ["famille", "familial", "confort", "séjour", "sejour", "convivial", "jardin", "espace"], url: uns("https://images.unsplash.com/photo-1704040686413-2c607dbd2f06"), alt: "Séjour familial" },
];

export function pickVisuals(text, n = 2) {
  const t = (text || "").toLowerCase();
  const scored = POOL.map((p, i) => ({
    ...p,
    idx: i,
    score: p.tags.reduce((s, tag) => s + (t.includes(tag) ? 1 : 0), 0),
  }));
  scored.sort((a, b) => (b.score - a.score) || (a.idx - b.idx));
  const chosen = [];
  for (const p of scored) {
    if (chosen.length >= n) break;
    if (!chosen.find((c) => c.url === p.url)) chosen.push(p);
  }
  return chosen;
}
